import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import type { TypePostSkuImageResponse } from '~/types/product.types';

const ENDPOINT = '/api-lip/v1/sku/image';

/**
 * [상품관리][상품 등록/상세 모달] 상품 이미지 업로드 API
 */
export const fetchPostSkuImage = async (uploadFile: File) => {
  const { data } = await axiosInstance.post<TypePostSkuImageResponse>(
    ENDPOINT,
    { uploadFile },
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data.data;
};

/**
 * [상품관리][상품 등록/상세 모달] 상품 이미지 업로드 Mutation Hook
 */
export const usePostSkuImageMutation = () => {
  return useMutation({
    mutationFn: fetchPostSkuImage,
    meta: { silent: true },
  });
};
